module.exports = __webpack_public_path__ + "static/media/opensanshebrew-regular.a9ba37fe.woff2";